import { createActionGroup, props } from '@ngrx/store';
import { ArbeitszeitkontoInvalidation } from '../../server-side-events/arbeitszeitkonto-invalidation';
import { PausenUeberpruefung } from '../../server-side-events/pausenueberpruefung';

export const InvalidationsActions = createActionGroup({
  source: 'Invalidations',
  events: {
    'Fill ArbeitszeitKontoInvalidations': props<{
      azkInvalidations: ArbeitszeitkontoInvalidation[] | undefined;
    }>(),
    'Fill Pausenueberpruefungen': props<{
      pausenUeberpruefungen: PausenUeberpruefung[] | undefined;
    }>(),
  },
});
